import {
  CustomButton2,
  CustomModal,
  CustomView, ResponsiveView,
} from "../../../../../../components";
import Context from "../../../../../../context";
import api from "../../../../../../api";
import React from "react";
import "./index.sass";
import { useTranslation } from "react-i18next";
import errorHandler from "../../../../../../utils/errorHandler";
import successHandler from "../../../../../../utils/successHandler";

const Payment: React.FC = (): React.ReactElement => {

  const { setSelectedFactors, selectedFactors, reFetch } = React.useContext(Context.PaymentOnline2CompanyContext)
  const [isOpenModal, setIsOpenModal] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const { t } = useTranslation();

  const onSubmitHandler = async (): Promise<void> => {
    if(selectedFactors?.length <= 0) return errorHandler(3502);
    setIsLoading(true);
    const result = await api.post.administrator.payPaymentOnline2Company(selectedFactors);
    console.log(result);
    if (result?.CODE === 2213) {
      await reFetch!();
      successHandler(2010);
      setSelectedFactors!([]);
      setIsOpenModal(false);
    }
    setIsLoading(false);
  };

  return (
    <>
      <ResponsiveView.Column medium={5}>
        <CustomButton2 title={' پرداخت بدهی به شرکت '} onClick={() => setIsOpenModal(true)} type={'success'} />
      </ResponsiveView.Column>
      <CustomModal
        onClose={() => {
          setIsOpenModal(false)
          // setFormData({});
          // setStep(1);
        }}
        open={isOpenModal}
        // minWidth={"40vw"}
        maxWidth={"45vw"}
        maxHeight={"30vh"}
      >
        <h6>تایید پرداخت</h6>
        <div style={{ width: "100%", marginTop: "2rem" }}>
          <CustomView.Row className="form-column-row">
            <div className="message-row">
              <span> جهت پرداخت بدهی به شرکت ها تایید کنید</span>
            </div>
          </CustomView.Row>
          <div style={{ width: "100%", marginTop: "2rem" }}>
            <CustomView.Row className="form-column-row">
              <CustomButton2 title={t("submit")} onClick={onSubmitHandler} />
            </CustomView.Row>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default Payment;
